import React, { useEffect, useState } from 'react';
import './style.scss';
import { Owner } from '../../components/Owner';
import { useParams } from 'react-router-dom';
import firebase from '../../firebase';
import { VideoPlayer } from '../../components/VideoPlayer/VideoPlayer';

export const VideoPreview = () => {
  const { id } = useParams();
  const [{ config, url, username, name, created_at }, setData] = useState({});

  useEffect(() => {
    var db = firebase.firestore();
    var docRef = db.collection('videos').doc(id);
    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          const data = doc.data();
          console.log('Document data:', doc.data());
          setData({
            ...data,
            config: JSON.parse(data.config),
          });
        } else {
          console.log('No such document!');
        }
      })
      .catch(function (error) {
        console.log('Error getting document:', error);
      });

    return () => {};
  }, [id]);

  return (
    <div className={'content'}>
      {config && url && (
        <div className={'videoplayer-container'}>
          <VideoPlayer isEditMode={false} src={url} config={config} />
        </div>
      )}
      {username && created_at && (
        <div className={'info'}>
          <h1>{name}</h1>
          <Owner name={username} date={created_at.toDate().toDateString()} />
        </div>
      )}
    </div>
  );
};
